import { z } from 'zod';

export const ATTACHMENT_ALLOWED_EXTENSIONS = ['.pdf', '.doc', '.docx', '.xls'] as const;
export const ATTACHMENT_MAX_SIZE_BYTES = 20 * 1024 * 1024;

/**
 * Attachment response shape. Used by single-download (REQ-2.13) and bulk-download manifest (REQ-9.4).
 * The bulk manifest shape omits `uploadedAt` — see `BulkDownloadManifestResponseSchema`.
 */
export const AttachmentSchema = z.object({
  id: z.number(),
  filename: z.string(),
  fileType: z.enum(['pdf', 'doc', 'docx', 'xls']),
  sizeBytes: z.number(),
  uploadedAt: z.string().datetime(),
  downloadUrl: z.string().url(),
});

export type Attachment = z.infer<typeof AttachmentSchema>;

export const AttachmentUploadResponseSchema = z.object({
  data: AttachmentSchema,
});

export type AttachmentUploadResponse = z.infer<typeof AttachmentUploadResponseSchema>;
